// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'crown',
  icon: [
    512,
    359,
    null,
    null,
    'M487.32 109.5a24.76 24.76 0 0 0-22.4 35.28l-135.35 60.18-62.34-157.33a24.8 24.8 0 1 0-17 .85l-62.36 157.5-140.2-62.31a24.76 24.76 0 1 0-11.95 12.8l58.76 201.68h326.15l58.47-200.53a24.76 24.76 0 1 0 8.19-48.15',
  ],
})
